import { MessageCircle, Radio, Instagram, Facebook } from "lucide-react";
import { SOCIAL } from "@/data/site";

const ICONS = { MessageCircle, Radio, Instagram, Facebook };

export const SocialLinks = ({ dark = true, withLabels = false, className = "" }) => (
  <div className={`flex flex-wrap gap-3 ${className}`} data-testid="social-links">
    {SOCIAL.map((s) => {
      const Icon = ICONS[s.icon];
      return (
        <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.label} title={s.label} data-testid={`social-${s.id}`}
          className={`inline-flex items-center gap-2 rounded-full border text-sm transition-colors duration-300 ${withLabels ? "px-4 py-2.5" : "p-3"} ${
            dark ? "border-sand/25 text-sand/80 hover:border-terra hover:text-terra" : "border-wood/25 text-bark hover:border-terra hover:text-terra"
          }`}>
          <Icon className="w-4 h-4" />
          {withLabels && <span>{s.label}</span>}
        </a>
      );
    })}
  </div>
);
